import internal from 'stream';
import { DocTypeSectionCompaniesDTO } from './docTypeSectionCompanies.model';
import { FiscalAgentDTO } from './fiscalAgent.model';
import { LookupDTO } from './lookup.model';
import { ManagementDataDTO } from './managementData.model';
import { SocialSecurityContributionsDTO } from './socialSecurityContributions.model';
import { StableOrganisationDTO } from './stableOrganisation.model';
import { CompanyCommercialProductDTO } from './commercialProduct.model';

/**
 * Modello per memorizzare i dati dell'azienda
 */
export class CompanyDTO {
  public ID: number;
  public Username2C: string;
  public Password2C: string;
  public UsernamePortale: string;
  public PasswordPortale: string;
  public Denomination: string;
  public Name: string;
  public Surname: string;
  public VatNumber: string;
  public FiscalCode: string;
  public Telephone: string;
  public Mobile: string;
  public Address: string;
  public City: string;
  public District: string;
  public PostalCode: string;
  public Email: string;
  public WebSite: string;
  public Nation: LookupDTO;
  public FK_Nation: string;
  public TaxRegime: LookupDTO;
  public PPID: string;
  public REANumber: string;
  public OfficeDistrict: string;
  public SocialCapital: number;
  public ShareholderType: LookupDTO;
  public BeingWoundup: LookupDTO;
  public VatRateFee: LookupDTO;
  public VatRateBollo: LookupDTO;
  public FK_Ateco: number;
  public Ateco: LookupDTO;
  public DocumentCausal: string;
  public CicpPercentage: number;
  public CashDeskType: LookupDTO;
  public SocialSecurityWithholdingCashDesk: boolean;
  public AdministrationReference: string;
  public WithholdingTaxPercentage: number;
  public WithholdingType: LookupDTO;
  public WithholdingCausal: LookupDTO;
  public Ritenuta20: boolean;
  public Ritenuta23: boolean;
  public Ritenuta2320: boolean;
  public Ritenuta2378: boolean;
  public SocialSecurityWithholdingType: LookupDTO;
  public SocialSecurityWithholdingCausal: LookupDTO;
  public EnasarcoPercentage: number;
  public TimeTable: boolean;
  public TimeTableXML: boolean;
  public StampCharge: boolean;
  public StampSubjectCash: boolean;
  public StampChargeFRF: boolean;
  public StampSubjectCashFRF: boolean;
  public StampManualForced: boolean;
  public IBAN: string;
  public StaticInvoiceDate: Date;
  public CodeArticleEnabled: boolean;
  public GeneralSalesConditions: string;
  public Icon: string;
  public Base64Icon: File;
  public AutoEmailType: AutoEmailTypeEnum;
  public HelpWizard: boolean;
  public AttachPdfToXml: boolean;
  public LastAccounting: Date;
  public Country: string;
  public LATX: number;
  public LNGX: number;
  public CanImpersonate: boolean;
  public FK_ParentCompany: number;
  public CommercialLevel: LookupDTO;
  public UserDisabled: boolean;
  public CreatedInFatturePlus: boolean;
  public SwitchedToFatturePlus: boolean;
  public SysAdministrator: boolean;
  public ManagementData: ManagementDataDTO[];
  public EoriCode: string;
  public Fax: string;
  public FK_FiscalAgent: number;
  public FK_StableOrganisation: number;
  public StreetNumber: string;
  public Title: string;
  public ProfessionalRegister: string;
  public ProvinceRegister: string;
  public RegistrationDateRegister: Date;
  public DataInizioAttivita: Date;
  public RF19ControlType: RF19ControlTypeEnum;
  public RF19InitCashedValue: number;
  public RF19InitCashedDate: Date;
  public RF19InitSalesValue: number;
  public RF19InitSalesDate: Date;
  public RegistrationNumberRegister: string;
  public FiscalAgent: FiscalAgentDTO;
  public StableOrganisation: StableOrganisationDTO;

  public VatPaymentPeriod: VatPaymentPeriodEnum;
  public IsSequentialIdentifier: boolean;  
  public DocumentProfileDefault: LookupDTO;
  public SectionDefault: string;
  public SocialSecurityContributions: SocialSecurityContributionsDTO[];
  public DocTypeSectionCompanies: Array<DocTypeSectionCompaniesDTO>;
  public ReminderTemplates: any[];
  public AuthFE: boolean;
  public AuthSPID: boolean;
  public FromShopQueue: boolean;
  public FK_CommercialProductInUse: number;
  public IsCommercialProductInUseExpired: Date;
  public PDFDocumentType: PDFDocumentTypeEnum;
  public PDFDocumentFilename: string;
  public PDFDocumentNumberPattern: number;

  public UtmDenomination: string;
  public NamirialAccount: string;
  public FK_Utm: number;
  public PreRegisteredCompany: boolean;
  public LastLoginDate: Date;
  public LastLoginUser: string;
   
  public RF19CheckSales: number;
  public RF19CheckCashed: number;
  public RF19Sales: number;
  public RF19Cashed: number;
  public RF19SalesPercentage: number;
  public RF19CashedPercentage: number;
  public RF19LimitOutNextYear: number;
  public RF19LimitOutNow: number;  

  public ChargeBeeStatus: ChargeBeeStatusEnum;

  public DoppiaContribuzioneINPS: boolean;
  public CodiceAteco: string;
  public SpeseGeneraliexArt13des: string;
  public SpeseGeneraliexArt13rate: number;

  public CompanyType: CompanyTypeEnum;
  public TipoSoggetto: number;
  public isNamirialPayActive: number;
  public FK_CompanyPayEmailTemplate: number;
  public FK_EmailTemplateRemainder: number;
  public FK_EmailTemplateReceipt: number;
  public NamPayDaysScheduler: number;
  public NamPayDaysRemainder: number;

  public STSCodiceIdentificativo: string;
  public STSPassword: string;  
  public STSPin: string;  
  public STSCFProprietario : string;
  public STSCodiceRegione: string;
  public STSCodiceASL: string;
  public STSCodiceSSA : string;
  public STSTipoSpese  : string;
  public STSTipoUtente   : LookupDTO
  public STSFlagTipodispesa  : STSFlagTipodispesaEnum;    
  public STSTipoPagamento: LookupDTO;
  public STSSection: string;

  //Francia
  public FR_Siren :string
  public FR_Nic :string
  public FR_TVA :string
  public FR_Siret :string
  public FR_CommercialName :string  
  public FR_ComplementAddress :string
  public FR_CountrySubentity :string  
  public FR_LegalInformation :string

  public hasPassword2C: boolean;
  public hasPasswordPortale: boolean;
  public hasPasswordSTS: boolean;
  public hasPinSTS: boolean;

}

export class CompanyListDTO {
  public ID: number;
  public Denomination: string;
  public Name: string;
  public Surname: string;
  public VatNumber: string;
  public FiscalCode: string;
  public Telephone: string;
  public Mobile: string;
  public Address: string;
  public City: string;
  public District: string;
  public PostalCode: string;
  public Email: string;
  public WebSite: string;
  public GeneralSalesConditions: string;
  public FullAddress: string;
  public IBAN: string;
  public DocumentCausal: string;
  public HasTaxRegime: boolean;
  public HasTimeTable: boolean;
  public CanMassiveDelete: boolean;
  public HasCredentials2C: boolean;
  public FK_User: string;
  public FK_CommercialLevel: number;
  public SysAdministrator: boolean;
  public CreatedInFatturePlus: boolean;
  public IsSequentialIdentifier: boolean;
  public AuthSPID: boolean;
  public AuthFE: boolean;
  public FromShopQueue: boolean;
  public FK_CommercialProductInUse: number;
  public IsCommercialProductInUseExpired: Date;
  public PreRegisteredCompany: boolean;
  public HasSectionDocumentType: boolean;
  public ActiveInvoiceCounter: number;
  public PassiveInvoiceCounter: number;
  public LicenseValidFrom: Date;
  public LicenseValidTo: Date;
  public SKU: string;
  public FK_TaxRegime: string;  
  
  public RF19ControlType: RF19ControlTypeEnum;
  public RF19CheckSales: number;
  public RF19CheckCashed: number;
  public RF19Sales: number;
  public RF19Cashed: number;
  public RF19SalesPercentage: number;
  public RF19CashedPercentage: number;
  public RF19LimitOutNextYear: number;
  public RF19LimitOutNow: number;
  public PackageQuantity: number;
  public RemainingInvoices: number;
  public LastLoginDate: Date;
  public LastLoginUser: string;
  public ChildDetailProducts: Array<CompanyCommercialProductDTO>;
  public ChargeBeeStatus: ChargeBeeStatusEnum;
  public CodiceAteco: string;
  public CompanyType: CompanyTypeEnum;
  public TipoSoggetto: number;
  public isNamirialPayActive: number;
  public MyNamirialPurchaseAccount: string;
  public STSCodiceIdentificativo: string;
  public STSPassword: string;  
  public STSPin: string;  
  public STSCFProprietario : string;
  public STSCodiceRegione: string;
  public STSCodiceASL: string;
  public STSCodiceSSA : string;  
  public STSTipoSpese  : string;
  public STSTipoUtente   : LookupDTO
  public STSFlagTipodispesa  : STSFlagTipodispesaEnum;      
  public STStipoPagamento: LookupDTO;
  public FK_CompanyPayEmailTemplate: number;
  public FK_EmailTemplateRemainder: number;
  public FK_EmailTemplateReceipt: number;
  public NamPayDaysScheduler: number;
  public NamPayDaysRemainder: number;
  //Francia
  public FR_Siren :string
  public FR_Nic :string
  public FR_TVA :string
  public FR_Siret :string

}

export class CompanyDashboardStaticObject {
  public ActiveInvoiceCounter: number;
  public PassiveInvoiceCounter: number;
  public Denomination: string;
  public vatnumber: string;
  public Telephone: string;
  public Email: string;
  public LicenseValidFrom: Date;
  public LicenseValidTo: Date;
  public SKU: string;
  public CommercialProductInUse: string;
  public PackageQuantity: number;
  public RemainingInvoices: number;
  public LastLoginDate: Date;
  public ChildDetailProducts: Array<CompanyCommercialProductDTO>;
  public AuthSPID: boolean;
  public FK_TaxRegime: string;  
  public TipoSoggetto: number;
  public isNamirialPayActive: number;
  public MyNamirialPurchaseAccount: string;
  public RF19ControlType: RF19ControlTypeEnum;
  public RF19CheckSales: number;
  public RF19CheckCashed: number;
  public RF19Sales: number;
  public RF19Cashed: number;
  public RF19SalesPercentage: number;
  public RF19CashedPercentage: number;
  public RF19LimitOutNextYear: number;
  public RF19LimitOutNow: number;
  public CompanyType: CompanyTypeEnum;
  public DashBoardInfo: DashBoardInfo;
  public InfoPurchaseNamirialPayLink: InfoPurchaseNamirialPayLink;
  public siret: string;
}

export class CompanyAddingProperties {
  public FK_vatRateBollo: number;
  public StampSubjectCash: boolean;
  // #BOLLO# QUESTI NON DOVRANNO ESSERE PIU' USATI
  public StampCharge: boolean;  
  public StampChargeFRF: boolean;
  public StampSubjectCashFRF: boolean;
}



export class DashBoardInfo {
  public FK_Company: number=0;
  public Anno: number=0;
  public Salesamount: number=0;
  public Cashedamount: number=0;
  public Dueamount: number=0;
  public Passiveamount: number=0;
  public InvoiceToSend: number=0;
  public InvoiceToSendError: number=0;
  public InvoiceRejected: number=0;    
}


export class InfoPurchasedInvoice {
  InvoiceCount: number;
  PurchaseDate: Date;
  PurchaseExpire: Date;
  ChildDetailProducts: Array<CompanyCommercialProductDTO>;
}

export class InfoPurchaseNamirialPayLink {
  LinkPurchased: number; 
  LinkActive: number; 
  LinkSent: number; 
  LinkUsed: number; 
  LinkAvailable: number; 
  LinkRecoverable: number; 
  LinkPercent: number; 
  DetailProducts: Array<CompanyCommercialProductDTO>;
}

export enum AutoEmailTypeEnum {
  NONINVIARE,
  EMAILSTANDARD = 1,  // Email standard
  EMAIL2C = 2         // Email 2C
}

export enum VatPaymentPeriodEnum {
  MENSILE,
  TRIMESTRALE = 1
}

// FatturePLUSFrancia 
// export enum PDFDocumentTypeEnum {
//   PDF_EQP = 0, //0 perch� standard, quello che c'� attualmente di default
//   PDF_ASSOSOFTWARE = 1,
//   PDF_2C = 2,
// }

export enum PDFDocumentTypeEnum {
   PDF_EQP = 0
 }

export enum RF19ControlTypeEnum {
  BOTH = 0,      // Entrambi
  CASHED = 1,   // Incassato
  SALES = 2,    // Ricavi e compensi
  NONE = 3      // Nessun controllo
}

export enum ChargeBeeStatusEnum
{        
    NOTHING = 0,        // Nessuna sottoscrizione ChargeBee (es.Inside
    ACTIVE = 1,         // Sottoscrizione attiva con rinnovo automatico
    NOTRENEWING = 2,    // Sottoscrizione attiva con rinnovo automatico disabilitato
    CANCELED = 3        // Sottoscrizione disattivata
}

export enum CompanyTypeEnum
{        
  INSIDE = 0,        
  SHOP = 10,
  DESK = 20
}


// Predisposizione per la gestione di eventuali tipi di azienda
export enum AtecoCompanyType
{        
    NOTHING = 0,        // Ateco non speicificato
    STUDILEGALI = 1    // Studi legali    
}


export enum STSFlagTipodispesaEnum {
  NOTHING = 0,      // Nessuno
  TICKET = 1,       // Ticket
  INTRAMOENIA = 2  // Visita Intramoenia
}